import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const getDataTransferFiles = function(event, multipleAllowed) {
  if (multipleAllowed == null) { multipleAllowed = true; }
  let dataTransferItemsList = [];

  if (event.dataTransfer) {
    const dt = event.dataTransfer;
    if (dt.files && dt.files.length) {
      dataTransferItemsList = dt.files;
    } else if (dt.items && dt.items.length) {
      dataTransferItemsList = dt.items;
    }
  } else if (event.target && event.target.files) {
    dataTransferItemsList = event.target.files;
  }

  if (dataTransferItemsList.length > 0) {
    dataTransferItemsList = multipleAllowed ? dataTransferItemsList : [dataTransferItemsList[0]];
  }

  return Array.prototype.slice.call(dataTransferItemsList);
};

export class Dropzone extends React.Component {
  static initClass() {
    this.propTypes = {
      activeClassName: PropTypes.string,
      className: PropTypes.string,
      accepts: PropTypes.oneOf(['all', 'images']),
      onDrop: PropTypes.func,
      onDragOver: PropTypes.func,
      onDragLeave: PropTypes.func
    };

    this.defaultProps = {
      className: 'drop-target',
      activeClassName: 'active',
      accepts: 'all'
    };
  }

  constructor(props) {
    super(props);
    this.onDrop = this.onDrop.bind(this);
    this.onDragOver = this.onDragOver.bind(this);
    this.onDragLeave = this.onDragLeave.bind(this);
    this.onDragEnter = this.onDragEnter.bind(this);

    this.state =
      {dragActive: false};
  }

  onDrop(event) {
    this.setState({dragActive: false});
    event.preventDefault();

    const files = getDataTransferFiles(event, false);
    if (this.isFileAccepted(files[0])) {
      return (typeof this.props.onDrop === 'function' ? this.props.onDrop(files[0]) : undefined);
    }
  }

  onDragOver(event) {
    let err;
    event.preventDefault();

    const files = getDataTransferFiles(event, false);
    if (this.isFileAccepted(files[0])) {
      this.setState({dragActive: true});
      try {
        return event.dataTransfer.dropEffect = 'copy';
      } catch (error) {
        err = error;
        return true;
      }
    } else {
      this.setState({dragActive: false});
      try {
        return event.dataTransfer.dropEffect = 'none';
      } catch (error1) {
        err = error1;
        return true;
      }
    }
  }


  onDragLeave(event) {
    this.setState({dragActive: false});
    return event.preventDefault();
  }

  onDragEnter(event) {
    this.setState({dragActive: true});
    return event.preventDefault();
  }

  isFileAccepted(file) {
    switch (this.props.accepts) {
      case 'images':
        return (file.type === 'application/x-moz-file') || (file.type.substr(0, 6) === 'image/');
      default:
        return true;
    }
  }

  render() {
    const classes = classNames(this.props.className,
      this.state.dragActive ? this.props.activeClassName : undefined);

    return <div className={classes}
          onDragEnter={this.onDragEnter}
          onDragOver={this.onDragOver}
          onDragLeave={this.onDragLeave}
          onDrop={this.onDrop}>
      {this.props.children}
    </div>;
  }
}
Dropzone.initClass();
